import { Injectable } from '@angular/core';
import { WizardModel, WizardStatus } from './WizardModel';
import { SERVICES } from '../constants/services';
import { ArticleModel, ModelsModel } from './ModelsModel';
import { env } from '../environments/environment';
import { ProposalModel } from './ProposalModel';


export class SelectionFilters {
  filter: {
    brands: Array<string>,
    collectionCode: Array<String>,
    colorCode: Array<string>,
    distrCh: string,
    features: Array<string>,
    fittingCode: Array<string>,
    genderCode: Array<string>,
    materialGroupCode: Array<string>,
    salesOrg: string,
    countryCode:string,
    seasonCodeAndYear: Array<string>,
    size: Array<string>,
    opticals: Array<string>,
    selectionCode: string
  }
  idSelection:string;
  search: string;
  offset: number;
  limit: number;
  sortBy: string;
  sortOrder: string;
}
@Injectable()
export class SelectionModel extends WizardModel {

  name: string;
  code: string;
  salesOrg: any;
  removedModels: any;
  isMarketSelection:boolean=false;

  init(obj: any = {}) {
    Object.assign(this, obj);

  }
  async load() {

    var data = await this.backend.request(SERVICES["SELECTIONS"].get, { id: this.id, offset: 0, limit: 1 });
    data = Object.assign(data, data.selection);
    this.init(data);
  }
  async count(filter) {
    var data = await this.backend.request(SERVICES["SELECTIONS"].count, filter);
    return data["count"]
  }

  async getModels(filter: any) {
    if(this.articleCount==0)
      return [];
    let listOfModels: Array<any> = [];
    let modelListDetails: Array<ModelsModel> = [];
    filter.username = this.userModel.username;
    return await this.backend.request(SERVICES["SELECTIONS"].getModels, filter).then((data) => {
      modelListDetails = data;
      modelListDetails.forEach(element => {
        element.brandName = this.userModel.getBrandNameFromCode(element.brandCode);
        element.seasonYears = element.seasonCode + " " + element.year.substring(2,4);
        this.backend.getImageUrl(element);
      });
      return modelListDetails;
    }).catch((error) => {
      console.log(error);
      return modelListDetails;
    });
  }
  getDetails(filter: any) {

    let list = [];
    for (var i = filter.offset; i < (filter.offset + filter.limit); i++) {
      let item = {

        styleName: 'GG014S' + i,
        salesOrg: 'FR11',
        distrCh: 'CH',
        country: 'FR',
        styleCount: 2,
        skuCount: 3,
        sunCount: 125,
        opticalCount: 0,
        dateCreated: '2019-01-01',
        price: 36250.34,
        images: ['https://apackeraqasblob.blob.core.windows.net/hash/46b/46b454b12c0fb7ab9e6811686955b214.jpeg',
          'https://apackeraqasblob.blob.core.windows.net/hash/46b/46b454b12c0fb7ab9e6811686955b214.jpeg',
          'https://apackeraqasblob.blob.core.windows.net/hash/46b/46b454b12c0fb7ab9e6811686955b214.jpeg',
          'https://apackeraqasblob.blob.core.windows.net/hash/46b/46b454b12c0fb7ab9e6811686955b214.jpeg'
        ]
      };
      list.push(item);

    }
    return list;
  }
  async getDetailCount(filter) {
    let filters = {
      id: filter.filter.id,
      limit: 1,
      offset: 0,
      filter: {
        brands: filter.filter.brands,
        category: (filter.filter.materialGroupCode && filter.filter.materialGroupCode.length == 1) ? filter.filter.materialGroupCode[0] : "" 
      },
      search: filter.search? filter.search : "",
      sortBy: filter.sortBy,
      sortOrder: filter.sortOrder
    }
    var tot = await this.backend.request(SERVICES["SELECTIONS"].countArticles, filters).then((el) => {
      return el.count;
    })
    return tot;
  }

  async getModelsCount(filter) {
    if(this.articleCount==0)
       return 0;

    filter.username = this.userModel.username;
    var data = await this.backend.request(SERVICES["SELECTIONS"].getModelsCount, filter);
    return data["count"]
  }

  async export(){
    var name= this.name.replace(" ", "_")
    var filename=`KE_Sales_Campaign_-_${this.name}_${new Date().getTime()}.xlsx`;
    var data=await this.backend.getExcel(SERVICES["SELECTIONS"].export+"/"+this.id+"/"+`viewRsp/${this.userModel.showPricesSRP}/viewWsh/${this.userModel.showPricesWHS}`, filename);
    return  data;
  }


  async getArticlesFromStyleName(styleName){

    let filter = {
      id: this.id,
      limit: 100000,
      offset:0,
      search:styleName,
      filter: {
        id: this.id,
        brands: [],
        category:  "" 
      }
    }

    return this.getArticles(filter);

  }


  async getArticles(filter: any) {
    let filters = {
      id: filter.filter.id,
      limit: filter.limit,
      offset: filter.offset,
      filter: {
        brands: filter.filter.brands,
        category: (filter.filter.materialGroupCode && filter.filter.materialGroupCode.length == 1) ? filter.filter.materialGroupCode[0] : "" 
      },
      search: filter.search? filter.search : "",
      sortBy: filter.sortBy,
      sortOrder: filter.sortOrder
    }
    let listOfModels: Array<any> = [];
    let listArticles: Array<ArticleModel> = [];
    return this.backend.request(SERVICES["SELECTIONS"].getArticles, filters).then((el) => {
      listOfModels = el.selection.models;
      listOfModels.forEach((model) => {
        let collectionDescr = model.details.collectionDescr;
        model.articles.forEach((article) => {
          article.details.collectionDescr = collectionDescr;
          article.details.seasonYears = article.details.seasonCode + " " + article.details.year.substring(2,4);
          if (article.details.images && article.details.images.cat) {
            if (article.details.images.cat.xxl && article.details.images.cat.xxl.filename)
              article.details.images.cat.xxl.filename = env.imageUrl + article.details.images.cat.xxl.filename;
            if (article.details.images.cat.s && article.details.images.cat.s.filename)
              article.details.images.cat.s.filename= env.imageUrl + article.details.images.cat.s.filename;
          }
          if (article.details.images && article.details.images.front) {
            if (article.details.images.front.xxl && article.details.images.front.xxl.filename) {
              article.details.images.front.xxl.filename = env.imageUrl + article.details.images.front.xxl.filename;
            }
            if (article.details.images.front.s && article.details.images.front.s.filename) {
              article.details.images.front.s.filename = env.imageUrl + article.details.images.front.s.filename;
            }
          }
          if (article.details.images && article.details.images.fom) {
            if (article.details.images.fom.xxl && article.details.images.fom.xxl.filename)
              article.details.images.fom.xxl.filename = env.imageUrl + article.details.images.fom.xxl.filename;
            if (article.details.images.fom.s && article.details.images.fom.s.filename)
              article.details.images.fom.s.filename = env.imageUrl + article.details.images.fom.s.filename;
          }
          listArticles.push(article.details);
        })
      })
      return listArticles;
    }).catch((error) => {
      console.log(error);
      return listArticles;
    });
  }

  

  async getList(filter: any) {

    var data = await this.backend.request(SERVICES["SELECTIONS"].list, filter);

    let list = [];

    data.forEach(lObj => {
      lObj = Object.assign(lObj, lObj.selection);
      let item = new SelectionModel(this.backend, this.userModel);
      item.init(lObj);
      list.push(item);

    });

    return list;

  }

  async save() {

    var data = await this.backend.request(SERVICES["SELECTIONS"].save, this.getObjToSave());
    this.id = data["id"];
    this.creationDate = data["creationDate"];
  }
  async delete() {
    var data = await this.backend.delete(SERVICES["SELECTIONS"].delete + '/' + this.id);
    return data;
  }
  getCopy() {
    var copy = {};
    let key = ""
    for (key in this) {
      if (typeof this[key] === 'string' || typeof this[key] === 'number' || Array.isArray(this[key]))
        copy[key] = this[key];
    }
    copy["isMarketSelection"]=this.isMarketSelection;
    return copy;
  }

  getObjToSave() {
    return {
      "country": this.country,
      "distrCh": this.distrCh,
      "id": this.id,
      "name": this.name,
      "brands": this.brands,
      "status": this.status,
      "salesOrg": this.salesOrg,
      "isMarketSelection":this.isMarketSelection,
      "removedModels":null,
      "username": this.username
    }
  }
  async addModel(model: any) {
    var obj = {
      "id": this.id,
      "distrCh": this.distrCh,
      "salesOrg": this.salesOrg,
      "country": this.country,
      "models": [
        {
          "styleCode": model.styleCode,
          "brandCode": model.brandCode,
          "isOptical": model.materialGroupCode == 'MG-0002',
          "isSunglass": model.materialGroupCode == 'MG-0001',
          "articles": null
        }
      ]

    }

    var data = await this.backend.request(SERVICES["SELECTIONS"].add, obj);
    await this.load();
    return data;

  }
  async removeModel(model: any) {
    var obj = {
      "id": this.id,
      "distrCh": this.distrCh,
      "salesOrg": this.salesOrg,
      "country": this.country,
      "models": [
        {
          "styleCode": model.styleCode,
          "brandCode": model.brandCode,
          "isOptical": model.materialGroupCode == 'MG-0002',
          "isSunglass": model.materialGroupCode == 'MG-0001',
          "articles": null
        }
      ]

    }

    var data = await this.backend.request(SERVICES["SELECTIONS"].remove, obj);
    await this.load();

  }

  async addSearch(filter: any) {
    var search = Object.assign({}, filter);
    search.limit = 300000;
    var obj = {
      "id": this.id,
      "search": search

    }

    var data = await this.backend.request(SERVICES["SELECTIONS"].add, obj);
    await this.load();

  }

  async removeBrands(brandList)
  {
    var filter={
      filter:{
        brands:brandList,
      distrCh: this.distrCh,   
      salesOrg: this.salesOrg,
      countryCode:this.country
    
      },
      offset:0,
    }
    await this.removeSearch(filter);
  }

  async duplicate(){

    
    var data = await this.backend.request(SERVICES["SELECTIONS"].duplicateAndMove, {
      id:this.id,
      name: this.name,
      salesOrg:this.salesOrg,
      distrCh:this.distrCh,
      country:this.country
    });
    this.isDuplicated=false;
    this.init({
      id:data.id,
      status: WizardStatus.BOZZA,
      username:this.userModel.username
    });
    
    await this.save();
    await this.load();
    return data.models;
    
  }

  async removeSearch(filter: any) {
    var search = Object.assign({}, filter);
    search.limit = 300000;
    search.username = this.userModel.username;
    var obj = {
      "id": this.id,
      "search": search

    }

    var data = await this.backend.request(SERVICES["SELECTIONS"].remove, obj);
    await this.load();

  }
  async addArticles(articles:Array<any>, model) {
    
    var arts= articles.map((article)=>{
      return{
        "skuCode": article.skuCode,
        
      }
    })
    
        
    var obj = {
      "id": this.id,
      "distrCh": this.distrCh,
      "salesOrg": this.salesOrg,
      "country": this.country,
      "models": [
        {
          "styleCode": model.styleCode,
          "brandCode": model.brandCode,
          "isOptical":model.materialGroupCode== 'MG-0002',
          "isSunglass": model.materialGroupCode == 'MG-0001',
          "articles": arts
        }
      ]
    }

    var data = await this.backend.request(SERVICES["SELECTIONS"].add, obj);
    await this.load();
    return data;
  }

  async addArticle(article: any, model) {
    var obj = {
      "id": this.id,
      "distrCh": this.distrCh,
      "salesOrg": this.salesOrg,
      "country": this.country,
      "models": [
        {
          "styleCode": model.styleCode,
          "brandCode": model.brandCode,
          "isOptical": model.materialGroupCode == 'MG-0002',
          "isSunglass": model.materialGroupCode == 'MG-0001',
          "articles": [{
            
            "skuCode": article.skuCode,
            
          }]
        }
      ]
    }

    var data = await this.backend.request(SERVICES["SELECTIONS"].add, obj);
    await this.load();
    return data;
  }

  async removeArticle(article: any, model?: any) {
    var obj = {
      "id": this.id,
      "distrCh": this.distrCh,
      "salesOrg": this.salesOrg,
      "country": this.country,
      "models": [
        {
          "styleCode": model?model.styleCode:article.materialCode,
         // "brandCode": model.brandCode,
          //"isOptical": model.materialGroupCode == 'MG-0002',
          //"isSunglass": model.materialGroupCode == 'MG-0001',
          "articles": [{
            "skuCode": article.skuCode,
           // "tags": article.tags
          }]
        }
      ]
    }

    var data = await this.backend.request(SERVICES["SELECTIONS"].remove, obj);
    await this.load();

  }
}